import { render } from "./ControlloStorniRid.vue?vue&type=template&id=a6b80968"
import script from "./ControlloStorniRid.vue?vue&type=script&lang=js"
export * from "./ControlloStorniRid.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__